import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { store } from '../store/store';

/**
 * Redux Provider wrapper component
 */
export function ReduxProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}

ReduxProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
